export default __webpack_public_path__ + "media/images/svg-bend-2-f4b32064dd44b1941f89a9b7698bfb35.svg";